import instance from './instance';

export const downloadDailyPnL = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/download/download_daily_pnl', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching daily PnL data:', error);
    throw error;
  }
};

export const downloadDailyPnLByStrategy = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get(
      '/v1/download/download_daily_pnl_by_strategy',
      {
        params: query,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching daily PnL data:', error);
    throw error;
  }
};

export const downloadDailyGreeks = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/download/download_daily_greeks', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching daily Greek data:', error);
    throw error;
  }
};

export const downloadDailyGreeksPnL = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get(
      '/v1/download/download_daily_greeks_pnl',
      {
        params: query,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching daily Greek data:', error);
    throw error;
  }
};

export const downloadDailyModelPerformance = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get(
      '/v1/download/download_daily_model_performance',
      {
        params: query,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching daily model performance data:', error);
    throw error;
  }
};

export const downloadIndexPrice = async ({ queryKey }) => {
  try {
    const [, query] = queryKey;
    const response = await instance.get('/v1/download/download_index_price', {
      params: query,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching index price data:', error);
    throw error;
  }
};
